// Gorgias Chat Event Listener
var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});
var eventsToTrack = [
    { gorgias: "message:sent",     dl: "gorgias_message_sent" },
    { gorgias: "message:received", dl: "gorgias_message_received" },
    { gorgias: "widget:opened",    dl: "gorgias_widget_opened" },
    { gorgias: "widget:closed",    dl: "gorgias_widget_closed" }
];

initGorgiasChatPromise.then(function() {

      eventsToTrack.forEach(function (evt) {
        GorgiasChat.on(evt.gorgias, function (data) {
          Shopify.analytics.publish(evt.dl, {
            gorgias_event: evt.gorgias,
            gorgias_data: data || null
          });  
          console.log("Gorgias event tracked:", evt.dl, data);
        });
      });

})